<template>
  <div class="pg-main-layout">
    <Navbar />
    <ShutdownBanner />
    <div
      class="pg-main-layout__content"
      :class="{
        'with-pro-banner': true,
      }"
    >
      <div class="content__page">
        <component
          v-if="subLayoutData"
          :is="getSubLayoutComponent"
          :layoutProps="getSubLayoutProps"
          :subLayoutData="getChildLayoutData"
        >
          <slot></slot>
        </component>
        <slot v-else></slot>
      </div>
      <Footer />
    </div>
    <LoadingOverlay v-if="pageLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import BlankLayout from "@/layouts/BlankLayout.vue"
import InstaproWidget from "@/components/instapro_widget/InstaproWidget"
import Footer from "@/components/footer/Footer"
import MessageWidget from "@/components/message_widget/MessageWidget.vue"
import Navbar from "@/components/navigation/Navbar"
import ShutdownBanner from "@/components/navigation/banner/ShutdownBanner"
import SaleBanner from "@/components/navigation/banner/SaleBanner"
import LoadingOverlay from "@/components/overlays/LoadingOverlay"

export default {
  components: {
    Footer,
    ShutdownBanner,
    InstaproWidget,
    LoadingOverlay,
    MessageWidget,
    Navbar,
    SaleBanner,
  },
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("Util", [
      "hideGoProBanner",
      "hideSaleBanner",
      "loadingSaleBanner",
      "pageLoading",
    ]),
    ...mapGetters("User", ["getUser", "isUserPro"]),
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

.pg-main-layout {
  background: linear-gradient(180deg, #000000 0%, #13092D 62.52%);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  .pg-main-layout__navbar {
    position: relative;
  }

  .pg-main-layout__content {
    position: relative;

    &.with-pro-banner {
      top: 5.5rem;
    }
  }

  .pg-main-layout__content {
    background-color: $gray;
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    flex: 1 1 auto;

    .content__page {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
    }

    .content__footer {
      flex: 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/MainLayout.vue